import React, { useEffect, useState } from 'react';
import UserListDumb from './UserListDumb';
import { useHistory, withRouter, useLocation } from 'react-router-dom';
import { useList, useUserManager } from 'components/hooks';
import { ErrorScreen, Alert, ModalAlert } from 'components/common';
import withRequest from 'hoc/withRequest';
import queryString from 'query-string';
import { ROUTES } from 'consts';


const UserListSmart = (props) => {
  const { getContentList, content, error, isLoaded } = useList('users');
  const history = useHistory();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [userSelected, setUserSelected] = useState(null);
  const user = useUserManager();
  let { search } = queryString.parse(props.location.search);

  const handleListPage = () => {
    const query = {}
    if (search) {
      query.search = search;
    }
    getContentList({ query });
  };


  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (user.success.get || user.success.post || user.success.put || user.success.delete) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ user.success.get, user.success.post, user.success.put, user.success.delete ]);

  const handleCleanUp = () => {
    user.cleanUpMessage();
  }

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.USER_CREATE);
  };


  const handleDelete = () => {
    const body = {
      username: userSelected.username
    }
    user.deleteUser({ body });
    setOpenModal(false);
  };

  const handleModalDelete = (user) => {
    setUserSelected(user);
    setOpenModal(true);
  };

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.USER_LIST}`;
    if (data.search !== '') {
      routeToPush = `${routeToPush}?search=${data.search}`
    }
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleEdit = (user) => {
    handleCleanUp();
    history.push(`${ROUTES.USER_EDIT}/${user.username}`);
  };


  const alerts = [
    {
      severity: 'success',
      open: user.success.post,
      message: 'userList.components.alert.success',
    },
    {
      severity: 'success',
      open: user.success.delete,
      message: 'userList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: user.success.put,
      message: 'userList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: user.error.put,
      message: 'userList.components.alert.error',
    },
    {
      severity: 'error',
      open: user.error.delete,
      message: 'userList.components.alert.error',
    },
    {
      severity: 'error',
      open: user.error.post,
      message: 'userList.components.alert.error',
    },
  ];

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <UserListDumb
          content={content}
          isLoaded={isLoaded}
          handleCreate = { handleCreate }
          handleDelete = { handleModalDelete }
          handleEdit = { handleEdit }
          handleSearch = { handleSearch }
          searchValue={search}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key = { index }
          severity = { alert.severity }
          handleClose = { () => user.cleanUpMessage() }
          open = { alert.open }
          message = { alert.message }
        />
      ))}

      <ModalAlert
        open={ openModal }
        handleClose={ () => setOpenModal(false) }
        handleConfirm={ handleDelete }
      />
    </>
  );
}

export default withRequest(withRouter(UserListSmart));
